











































import {
  computed,
  defineComponent,
  Ref,
  ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import companyBranch from '@/table/setting/company';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonFormWithBranchEditor from '@/components/Company/CommonFormWithBranchEditor.vue';

import getHubs from '@/gql/company/getHubs.gql';

const PanelWithBranchInformation = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonFormWithBranchEditor,
  },
  props: {
    companyId: { default: -1 },
  },
  setup() {
    const search: Ref<string> = ref('');
    const getHubsResult = (data: any) => data.me.company.hubs;
    // ==== Use to search User ==== //
    const getHubsVariables = computed(() => {
      const vars: {[key: string]: any} = {
        filterName: undefined,
      };
      if (search) {
        vars.filterName = `%${search.value}%`;
      }
      return vars;
    });

    const addBranchModal = ref(null);
    const pendingEditedBranch = ref({
      id: -1,
    });

    // =========================================
    // ===== Use to delete Hub from system =====
    // =========================================
    // const deleteHubModal = ref(null);
    // const deleteAreaCodeMutation = useMutation(deleteHub, {
    //   refetchQueries: ['getHubs'],
    // });
    // function deleteHubAction(hubId: number) {
    //   deleteAreaCodeMutation.mutate({
    //     id: hubId,
    //   });
    // }

    return {
      search,
      hubsTableOptions: companyBranch,
      getHubsQuery: getHubs,
      getHubsVariables,
      getHubsResult,

      addBranchModal,
      pendingEditedBranch,

      // deleteHubModal,
      // deleteHubAction,
    };
  },
});

export default PanelWithBranchInformation;
